import dayjs, { Dayjs } from "dayjs";

const startOfDay = () => dayjs().startOf("day");

export const defaultStartTime = () => startOfDay();
export const defaultEndTime = () => startOfDay();
export const defaultBreakStartTime = () => startOfDay();
export const getTotalBreakTime = (breakDuration: string | undefined, breakStartTime: Dayjs) => {
  const breakDurationAsTime = dayjs(breakDuration, "HH:mm");

  return breakStartTime
    .add(breakDurationAsTime.hour(), "hour")
    .add(breakDurationAsTime.minute(), "minute");
};
